<template>
  <div class="container">
    <div class="row">
      <div class="align-items-center w-100 text-white mt-5">
        <h1 class="align-items-center mt-40" align="center">Welcome</h1>
        <p class="align-items-center" align="center"> 
Sinai Recognized University for your bright future

        </p>
      </div>



      <div class="col-md-7 mx-auto">


        <div class="panal card-container">
          <div class="panal-header">Create New Account</div>

          <form name="form" @submit.prevent="handleRegister">
            <div v-if="!successful">

              <div class="row mt-40 p-20">
                <!-- First name-->
                <div class="col-md-6">

                  <div class="form-group ">
                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="user" />
                        </div>
                      </div>



                      <input v-model="user.FirstNameEN" v-validate="'required|min:3|max:20'" type="text"
                        class="form-control" name="FirstNameEN" placeholder="Enter Your First Name" />



                    </div>
                    <div v-if="submitted && errors.has('FirstNameEN')" class="alert-danger">
                      {{errors.first('FirstNameEN')}}
                    </div>
                  </div>
                </div>
                <!-- last name-->
                <div class="col-md-6">

                  <div class="form-group ">
                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="user" />
                        </div>
                      </div>
                      <input v-model="user.LastNameEN" v-validate="'required|min:3|max:20'" type="text"
                        class="form-control" name="LastNameEN" placeholder="Enter Your Last Name" />
                    </div>
                    <div v-if="submitted && errors.has('LastNameEN')" class="alert-danger">
                      {{errors.first('LastNameEN')}}
                    </div>
                  </div>
                </div>
                <!-- Email -->
                <div class="col-md-6">

                  <div class="form-group">

                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="envelope" />
                        </div>
                      </div>

                      <input v-model="user.Email" v-validate="'required|email|max:50'" type="email" class="form-control"
                        name="email" placeholder="Email" ref="email" />
                    </div>
                    <div v-if="submitted && errors.has('email')" class="alert-danger">{{errors.first('email')}}</div>

                  </div>


                </div>
                <!-- Confirm Email -->
                <div class="col-md-6">

                  <div class="form-group">

                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="envelope" />
                        </div>
                      </div>

                      <input v-validate="'required|confirmed:email'" name="email_confirmation"
                        :class="{'is-danger': errors.has('email_confirmation')}" placeholder="Confirm Email , Again"
                        data-vv-as="email" type="email" class="form-control" />


                    </div>
                    <div v-show="errors.has('email_confirmation')" class="help is-danger">
                      {{ errors.first('email_confirmation') }}</div>

                    <div v-if="submitted && errors.has('email')" class="alert-danger">{{errors.first('email')}}</div>
                  </div>


                </div>
                <!-- <div class="col-md-6">

                  <div class="form-group mt-10">

                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="phone-alt" />
                        </div>
                      </div>

                      <input type="number" v-model="user.NationalityId" class="form-control" name="NationalityId"
                        placeholder="2111-11123-11123" />


                    </div>

                  </div>
                </div> -->
                <!--Date Of Birth -->
                <div class="col-md-6">

                  <div class="form-group mt-10">

                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="calendar" />
                        </div>
                      </div>
                      <input type="date" class="form-control" name="Date" placeholder="Birth of date"
                        v-model="user.BirthDate" v-validate="'required'" />
                    </div>
                    <div v-if="submitted && errors.has('Date')" class="alert-danger">{{errors.first('Date')}}</div>

                  </div>
                </div>

                <!-- Gender List-->
                <div class="col-md-6">
                  <div class="form-group mt-10">
                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="transgender" />
                        </div>
                      </div>


                      <select v-validate="'required|excluded:0'" id="inputState" class="form-control" v-model="user.GenderID"
                        name="gender">
                        <option selected value="0">Choose...</option>
                        <option v-for="gender in GenderList" :value="gender.serial" v-bind:key="gender.serial">
                          {{gender.GenderName}}</option>

                      </select>

                    </div>
                    <div v-if="submitted && errors.has('gender')" class="alert-danger">{{errors.first('gender')}}</div>

                  </div>

                </div>

                <!-- National ID -->
                <div class="col-md-6">


                  <div class="form-group">
                    <div class="input-group mt-10">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="id-card" />
                        </div>
                      </div>
                      <input type="text" v-validate="'required|digits:14'" class="form-control" name="ID"
                        placeholder="123456789" v-model="user.NationID" />
                    </div>
                    <div v-if="submitted && errors.has('ID')" class="alert-danger">{{errors.first('ID')}}</div>

                  </div>

                </div>
                <!-- Nationality -->
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="input-group">

                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <font-awesome-icon icon="address-book" />
                        </div>
                      </div>

                      <select id="inputState" v-validate="'required|excluded:0'" class="form-control" v-model="user.NationalityId"
                        name="NationalityId">
                        <option selected value="0">Choose...</option>
                        <option v-for="national in nationalityList" :value="national.Serial"
                          v-bind:key="national.Serial">{{national.NationalityNameEN}}</option>

                      </select>
                    </div>
                    
                    <div v-if="submitted && errors.has('NationalityId')" class="alert-danger">
                      {{errors.first('NationalityId')}}</div>
                  </div>
                </div>

                <div  class="col-md-6">

                <span class="text-left">Select User Image</span>
                <div class="custom-file">
                <input type="file" v-validate="'required'" name="UserImage" class="custom-file-input su-border" id="customFile" accept="image/*" ref="file" v-on:change="handleFileUpload()">
                <label class="custom-file-label" for="customFile" >{{file.name ? file.name : "Choose file"}}</label>
              </div>
              <div v-if="submitted && errors.has('UserImage')" class="alert-danger mt-1">
                      {{errors.first('UserImage')}}</div>
                    </div>
              </div>

              <div class="col-md-6 mx-auto mt-20">
                <div class="form-group mt-10">
                  <button class=" btn-block btn btn-outline-secondary mt-10" :disabled="loading">
                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                    Sign Up</button>
                </div>
              </div>
            </div>
          </form>

          <div v-if="message" class="alert m-3" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
          <div class=" mt-40"></div>
          <div class="col-md-8 mx-auto">
          <h5 class="divider">Have Account</h5>
          </div>
          <div class=" mt-40"></div>
          <div class="form-group">
            <div class="col-md-6 mx-auto">
            <b-link class="text-decoration-none" @click="$router.push('login')">

             <button class=" btn-block btn btn-outline-secondary mt-10" :disabled="loading">back to login</button>
            </b-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  import {
    CreateApplicant
  } from '../models/user';

  import ApplicantService from "../services/Applicant/Applicant.service";
  export default {
    beforeCreate: function () {
      document.body.className = 'home';
    },
    name: 'Register',
    data() {
      return {
        user: new CreateApplicant('', '', '', '', 0, '', 0),
        submitted: false,
        successful: false,
        message: '',
        GenderList: [],
        nationalityList: [],
        loading: false,
        file:''
      };
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },
    mounted() {
      ApplicantService.GetGendelList().then(Response => {
        this.GenderList = Response.data
      }, error => {
        this.loading = false;
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });

      ApplicantService.GetNationalityList().then(Response => {
          this.nationalityList = Response.data
        }, error => {
          this.loading = false;
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        }

      );

      if (this.loggedIn) {
        this.$router.push('/profile');
      }
    },
    methods: {
       isArabicChars(text) {
      var arregex = /^[\u0621-\u064A\s\p{N}]+$/;
      return arregex.test(text);
    },
    
      handleFileUpload(){
 this.file = this.$refs.file.files[0];
},
      handleRegister() {
        this.message = '';
        this.submitted = true;
        if(this.isArabicChars(this.user.FirstNameEN)){
         alert('You are using arabic letters For First name English')
       }
       else if(this.isArabicChars(this.user.LastNameEN)){
         alert('You are using arabic letters For Last name English')
       }else{

       

        this.$validator.validate().then(isValid => {
          if (isValid) {
            this.loading = true;
            /*eslint-disable-next-line*/
            console.log(this.user)
           let formData = new  FormData();
           formData.append('UploadedFile', this.file);
           formData.append('FirstNameEN', this.user.FirstNameEN);
           formData.append('LastNameEN', this.user.LastNameEN);
           formData.append('NationalityId', this.user.NationalityId);
           formData.append('NationID', this.user.NationID);
           formData.append('GenderID', this.user.GenderID);
           formData.append('BirthDate', this.user.BirthDate);
           formData.append('Email', this.user.Email);

            this.$store.dispatch('auth/register', formData).then(
              data => {
                this.$store.state.ApplicantID = data
                this.message = data.message;
                this.successful = true;
                this.$router.push('/welcome')
              },
              error => {
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
                this.successful = false;
                this.loading = false;
              }
            );
          }
        });
        }
      },
    }
  };
</script>

<style scoped>
  label {
    display: block;
    margin-top: 10px;
  }

  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }

  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }

  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .panal {
    background: #0000009e;
    border-radius: 10px 10px 0px 0px;
    color: #fff;
    padding: 0px 0px 20px 0px;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;

  }

  .panal-header {
    background: #FFFFFF;
    color: #285475;
    text-align: center;
    border-radius: 10px 10px 0px 0px;
    padding: 15px;
    font-size: 30px;
    font-weight: bold;
    -moz-box-shadow: inset 0 0 5px #000000;
    -webkit-box-shadow: inset 0 0 5px #000000;
    box-shadow: inset 0 0 5px #000000;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  .p-20 {
    padding: 20px;
  }

  .form-control {

    color: #ffffff;
    background-color: #9191916b !important;
    background-clip: padding-box;
    border: 1px solid #ced4da75 !important;
  }

  .btn-outline-secondary {
    color: #ffffff;
    border-color: #ffffff;
  }

  ::placeholder {
    color: #fff !important;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff !important;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #fff !important;
  }

  .form-control:focus {
    color: #ffffff !important;
  }

  .divider {
    font-size: 20px;
    margin: -0.65em auto -0.45em;
    overflow: hidden;
    text-align: center;
    line-height: 1.2em;
  }

  .divider:before,
  .divider:after {
    content: "";
    vertical-align: top;
    display: inline-block;
    width: 50%;
    height: 0.65em;
    border-bottom: 1px solid #fff;
    margin: 0 2% 0 -55%;
  }

  .divider:after {
    margin: 0 -55% 0 2%;
  }

  @import url('../assets/style.css');
</style>